import React, { useState } from "react";
import { ExternalLink, Info, Zap, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const CreditstarAd = () => {
  const creditstarUrl = "https://on.creditstar.fi/t/t?a=1971698767&as=1854031059&t=2&tk=1";

  const handleCreditstarClick = () => {
    window.open(creditstarUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="bg-gradient-to-r from-blue-700 to-blue-900 rounded-xl p-8 text-white shadow-xl relative overflow-hidden max-w-5xl mx-auto">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full translate-y-12 -translate-x-12"></div>
      
      <div className="relative z-10">
        <div className="flex items-center mb-4">
          <div className="bg-white rounded-lg p-2 mr-4">
            <img 
              src="/lovable-uploads/9aa19572-3de1-48ab-8516-c45c17ab8760.png" 
              alt="Creditstar" 
              className="h-10 sm:h-12 md:h-14"
            />
          </div>
          <div className="flex items-center bg-yellow-400 text-black px-3 py-1 rounded-full text-sm font-bold">
            <Zap className="w-4 h-4 mr-1" />
            RAHAT HETI KÄYTÖSSÄ
          </div>
        </div>

        <h3 className="text-3xl font-bold mb-2 text-white">Lainaa jopa 3000 € asti</h3>
        <p className="text-blue-100 mb-6 text-lg">
          Creditstar on osa Creditstar Groupia - luotettava fintech-yritys, joka palvelee 
          yli 1,2 miljoonaa asiakasta Euroopassa.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <h4 className="font-semibold text-white mb-3">✅ Edellytykset:</h4>
            <ul className="text-blue-100 space-y-1">
              <li>• Yli 21-vuotias</li>
              <li>• Vakituinen työsuhde</li>
              <li>• Suomalainen pankkitili</li>
              <li>• Asuu vakituisesti Suomessa</li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-white mb-3">⚡ Edut:</h4>
            <ul className="text-blue-100 space-y-1">
              <li>• Rahat käytössä heti</li>
              <li>• Ei avausmaksua (0€)</li>
              <li>• Jatkuva luottolimiitti</li>
              <li>• Nopea päätös</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <Button 
            onClick={handleCreditstarClick}
            className="bg-white text-blue-900 hover:bg-blue-50 font-bold text-lg px-8 py-4 shadow-lg hover:shadow-xl transition-all flex-1 sm:flex-none"
          >
            <Clock className="mr-2 h-5 w-5" />
            Hae 3000€ luottotili heti
            <ExternalLink className="ml-2 h-5 w-5" />
          </Button>
          
          <Dialog>
            <DialogTrigger asChild>
              <Button 
                variant="outline" 
                className="border-2 border-white text-white hover:bg-white hover:text-blue-900 font-semibold transition-all bg-transparent"
              >
                <Info className="mr-2 h-4 w-4" />
                Lainaesimerkki
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto bg-white">
              <DialogHeader>
                <DialogTitle className="text-gray-900">Creditstar - Käyttöehdot ja lainaesimerkki</DialogTitle>
              </DialogHeader>
              <div className="space-y-4 text-gray-700">
                <div>
                  <h4 className="font-semibold mb-2 text-gray-900">Lainaesimerkki</h4>
                  <p className="text-sm text-gray-600">
                    Creditstar on vakuudeton 3000 euron asti jatkuva luotto, nimelliskorko 14,99%, 
                    luoton avausmaksu 0 euroa, tilinhoitomaksu 0,01% päivässä luottorajasta.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-semibold mb-2 text-gray-900">Esimerkki luoton takaisinmaksusta</h4>
                  <p className="text-sm text-gray-600">
                    Todellinen vuosikorko 2000 euron luotolle on 23,86%. Laskelmassa on huomioitu 
                    nimelliskorko 14,99%, lainanhoitokulu 6 euroa kuukaudessa. Lainan ja 
                    lainakustannusten yhteismäärä 2238,12 euroa, kun maksueriä on 12.
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold mb-2 text-gray-900">Kohderyhmä</h4>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Yli 21-vuotiaat</li>
                    <li>• Vakituisessa työsuhteessa</li>
                    <li>• Suomalainen pankkitili</li>
                    <li>• Asuu vakituisesti Suomessa</li>
                  </ul>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </div>
  );
};

export default CreditstarAd;